'use client';

import { usePathname, useRouter } from 'next/navigation';
import React, { useState } from 'react';
import { Headset } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';

export default function SupportFab() {
    const pathname = usePathname();
    const router = useRouter();

    React.useEffect(() => {
        if (!pathname?.startsWith('/admin')) {
            if (!document.getElementById('chatway-script')) {
                const script = document.createElement('script');
                script.id = 'chatway-script';
                script.async = true;
                script.src = 'https://cdn.chatway.app/widget.js?id=twYfelg0udOL';
                document.body.appendChild(script);
            }
        }
    }, [pathname]);

    // Do not show on admin pages
    if (pathname?.startsWith('/admin')) {
        return null;
    }

    if (pathname?.startsWith('/support')) {
        return null;
    }

    return (
        <div className="fixed bottom-24 right-6 z-50 flex flex-col items-end gap-4">
            {/* AI Support FAB - Positioned above Jivo (which is usually bottom-0 or bottom-4) */}
            <div className="group flex items-center gap-2">
                <span className="bg-white text-gray-800 px-4 py-1 rounded-lg shadow-md opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap text-sm font-medium hidden md:block">
                    AI Assistant
                </span>
                <button
                    onClick={() => router.push('/support')}
                    className="w-14 h-14 bg-gradient-to-tr from-indigo-500 via-purple-500 to-pink-500 hover:from-indigo-600 hover:via-purple-600 hover:to-pink-600 text-white rounded-full shadow-lg hover:shadow-2xl hover:shadow-purple-500/40 transition-all duration-300 flex items-center justify-center transform hover:-translate-y-1 relative overflow-hidden group/btn"
                    aria-label="AI Support Chat"
                >
                    <div className="absolute inset-0 bg-white/20 opacity-0 group-hover/btn:opacity-100 transition-opacity duration-300" />
                    <Headset size={24} className="relative z-10 group-hover/btn:scale-110 transition-transform duration-300" />
                </button>
            </div>
        </div>
    );
}
